/**
 * Loads and caches the Challenge Wheel UI content.
 * The challenge-wheel page awaits this on first load; all child components
 * call it without await and receive the already-cached result instantly.
 */
export function useChallengeWheelUI() {
  return useAsyncData('challenge-wheel-ui', () =>
    queryCollection('challengeWheelUI').first(),
  )
}
